import React from 'react'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { TEXT_CONSTANTS } from '../../../constants/Constants'

const DeleteButton = ({ onClick, disabled })=> {
    return (
        <div className='flex gap-1 '>

            <Button onClick={onClick} disabled={disabled} type="text" className="h-[27px] text-[#F22F23] bg-[rgba(242,47,35,0.3)] w-[65px] text-[10px] font-bold">
                <CloseCircleOutlined
                    className="text-[15px] text-[#F22F23]" />
                {TEXT_CONSTANTS.DELETE}
            </Button>
        </div>)
}




export default DeleteButton;
